import React, { useEffect, useState, useMemo } from "react"
import { MaterialReactTable, useMaterialReactTable } from "material-react-table"
import {
  TextField,
  createTheme,
  ThemeProvider,
  useTheme,
  Box,
  IconButton,
  Tooltip,
  TablePagination,
} from "@mui/material"

import Swal from "sweetalert2"
import { styled } from "@mui/material/styles"
import { esES } from "@mui/material/locale"
import { MRT_Localization_ES } from "material-react-table/locales/es"
import fetchwrapper from "../../../services/interceptors/fetchwrapper"
import EditIcon from "@mui/icons-material/Edit"
import { useNavigate } from "react-router-dom"
import EliminarIcon from "../../../assets/iconos/Eliminar.ico"
import DetalleIcon from "../../../assets/iconos/Detalle.ico"
import normalFormatDate from "../../utils/date/DDMMYYYFormatDate"
import normalFormatHour from "../../utils/date/HHMMSSFormatHour"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { DatePicker } from "@mui/x-date-pickers/DatePicker"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query"
import CustomBackdrop from "../../../components/CustomBackdrop"
const CustomTable = ({
  fetchedInfo = [],
  isLoadingInfoError,
  isLoadingInfo,
  isFetchingInfo,
  setProveedores,
  refetch,
  selectedProvs,
  setSelectedProvs,
  provsAnteriores,
  setProvsAnteriores,
}) => {
  // Preselect rows based on 'bodstatus' property value
  useEffect(() => {
    if (fetchedInfo.length > 0) {
      // Construye el estado inicial de selección basado en la propiedad `clicodigo`
      const initialSelection = {}
      const initialSelectedRows = []

      fetchedInfo.forEach((row) => {
        if (row.clicodigo !== null) {
          initialSelection[row.procodigo] = true
          initialSelectedRows.push(row) // Marca el índice de la fila como seleccionado
        }
      })
      setRowSelection(initialSelection)
      setSelectedProvs(initialSelectedRows)
      setProvsAnteriores(initialSelectedRows)
    }
  }, [fetchedInfo, setSelectedProvs, setProvsAnteriores])
  const navigate = useNavigate()
  // Maneja cambios en los filtros de la grilla

  const columns = useMemo(
    () => [
      {
        accessorKey: "acciones",
        header: "Acciones",
        enableColumnFilter: false,
        size: 150,
      },
      {
        accessorKey: "procodigo",
        header: "Codigo",
        enableEditing: false,
        size: 120,
      },

      {
        accessorKey: "pronombre",
        header: "Nombre",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "proruc",
        header: "Identificacion",
        enableEditing: false,
        size: 120,
      },
      {
        accessorKey: "protelef1",
        header: "Telefono",
        enableEditing: false,
        size: 120,
      },
    ],
    [navigate],
  )

  const [rowSelection, setRowSelection] = useState({})
  const table = useMaterialReactTable({
    columns,
    data: fetchedInfo.length > 0 ? fetchedInfo : [],
    enableEditing: false,
    enableRowSelection: true,
    enableRowActions: false,
    onRowSelectionChange: setRowSelection,

    localization: { ...MRT_Localization_ES },
    initialState: {
      showColumnFilters: true,
    },
    getRowId: (row) => `${row.procodigo}`,
    muiToolbarAlertBannerProps:
      // searchAttempted &&
      !isLoadingInfo && fetchedInfo.length === 0 && !isFetchingInfo
        ? {
            color: "info",
            children: "No se encontraron Proovedores",
          }
        : undefined,
    muiTableContainerProps: {
      sx: {
        minHeight: "500px",
      },
    },
    renderToolbarInternalActions: ({ table }) => <Box></Box>,

    state: {
      isLoading: isLoadingInfo,
      showAlertBanner: isLoadingInfoError,
      showProgressBars: isFetchingInfo,
      rowSelection,
    },
  })

  useEffect(() => {
    const selectedRowsData = table.getSelectedRowModel().flatRows.map((row) => row.original)
    setSelectedProvs(selectedRowsData)
  }, [rowSelection, setSelectedProvs])
  useEffect(() => {
    console.log("Seleccion actual:", selectedProvs)
    console.log("Originales:", provsAnteriores) // Mostrar las bodegas seleccionadas inicialmente
  }, [selectedProvs, provsAnteriores])
  return (
    <>
      <MaterialReactTable table={table} />
    </>
  )
}

const ProvAsociadosGrid = ({
  refetch,
  fetchedInfo,
  isLoadingInfo,
  isError,
  isFetchingInfo,
  setProveedores,
  selectedProvs,
  setSelectedProvs,
  provsAnteriores,
  setProvsAnteriores,
}) => {
  const theme = useTheme()

  // Maneja cambios en los filtros de la grilla

  return (
    <div>
      <ThemeProvider theme={createTheme(theme, esES)}>
        <CustomTable
          fetchedInfo={fetchedInfo}
          isLoadingInfoError={isError}
          isLoadingInfo={isLoadingInfo}
          isFetchingInfo={isFetchingInfo}
          refetch={refetch}
          setProveedores={setProveedores}
          selectedProvs={selectedProvs}
          setSelectedProvs={setSelectedProvs}
          provsAnteriores={provsAnteriores} // Pasar `bodegasAnteriores` al componente hijo
          setProvsAnteriores={setProvsAnteriores}
        />
      </ThemeProvider>
    </div>
  )
}

export default ProvAsociadosGrid
